<div
  class="content-card lesson-card body-under-media"
  tabindex="0"
  [ngClass]="['layout-' + layout, 'bundle-' + data.bundle]"
  [class.locked]="data.isLocked"
  [class.disabled]="!data.active"
  [attr.data-cy]="data.bundle + '-card-' + data.id"
  (click)="cardClick.emit($event)">
  <div class="content-card__media">
    <div class="content-card__media--image"
      [placeholderImage]="!data?.mediaImage && data.bundle"
      [cropImage]="(data?.mediaImage | preSignedUrl | async) || data.image"
      [crop]="data.mediaImage?.crop"
      imageWidth="400">
    </div>
    <div class="content-card__badges">
      @if (data.isLocked) {
        <div class="content-card__badges--item badge-dark" [matTooltip]="data.selectiveLockingItems?.length ? ('COMMON.selective_locked_list' | translate:{content: selectiveLockingItems}) : ('ERRORS.content_locked' | translate)">
          <lib-icon icon="lock-simple" [size]="16"></lib-icon> {{'MODULE_LESSON_CARD.locked' | translate}}
        </div>
      }
      @if (data.isNew && data?.progress !== 100) {
        <div class="content-card__badges--item badge-blue">{{'COMMON.new' | translate}}</div>
      }
      @if (data.nonMandatory) {
        <div class="content-card__badges--item badge-orange">
          <mat-icon svgIcon="lms-branch"></mat-icon> {{'COMMON.optional' | translate | titlecase}}
        </div>
      }
    </div>
    @if (!data.isLocked) {
      <div class="content-card__media--button">
        <button mat-flat-button class="button button--primary">
          <lib-icon [icon]="data.progress === 100 ? 'arrow-clockwise' : 'play'"></lib-icon>
          @if (data.progress === 100) {
            {{'COMMON.start_again' | translate}}
          }
          @if (data.progress && data.progress !== 100) {
            {{'COMMON.continue' | translate}}
          }
          @if (!data.progress) {
            {{'COMMON.start' | translate}}
          }
        </button>
      </div>
    }
    @if (data.progress && !hideProgress && cardsSettings?.lesson?.progress?.visible && data.progress !== 1) {
      <div class="content-card__media--progress progress-indicator">
        <mat-progress-bar class="default-theme" aria-label="Progress" mode="determinate" [value]="data.progress" data-cy="card-progress-bar"></mat-progress-bar>
      </div>
    }
  </div>
  <div class="content-card__body">
    <div class="content-card__body--label">
      @if (cardsSettings?.lesson?.type?.visible) {
        <div class="content-card__body--label-item text-uppercase" [style.order]="cardsSettings?.lesson?.type?.weight">
          <lib-icon [icon]="data.bundle === bundleType.LESSON ? 'book-open-text' : 'game-controller'" [size]="16"></lib-icon>
          {{ data | bundleLabel | async }}
        </div>
      }
      @if (data.time && cardsSettings?.lesson?.time?.visible) {
        <div [style.order]="cardsSettings?.lesson?.time?.weight" class="content-card__body--label-item">
          <lib-icon icon="clock" [size]="16"></lib-icon> {{data.time | minutesToTime : 'short' }}
        </div>
      }
      @if (data.leaderboardPoints && leaderboardEnabled && cardsSettings?.lesson?.leaderboardPoints?.visible) {
        <div [style.order]="cardsSettings?.lesson?.leaderboardPoints?.weight" [matTooltip]="'COMMON.content_complete_points' | translate:{points: data.leaderboardPoints}" class="content-card__body--label-item">
          <lib-icon icon="currency-eth" [size]="16"></lib-icon> {{data.leaderboardPoints}} {{'LEADERBOARD.pts' | translate | lowercase}}
        </div>
      }
      @if (data.achievements?.length && achievementsEnabled && cardsSettings?.lesson?.achievements?.visible) {
        <div [style.order]="cardsSettings?.lesson?.achievements?.weight" [matTooltip]="'COMMON.content_complete_achievements' | translate:{count: data.achievements?.length, content: achievementsTitle}" class="content-card__body--label-item">
          <lib-icon icon="medal" [size]="16"></lib-icon> {{'COMMON.achievement' | translate}}
        </div>
      }
      @if (data.certifications?.length && certificatesEnabled && cardsSettings?.lesson?.certificate?.visible) {
        <div [style.order]="cardsSettings?.lesson?.certificate?.weight" [matTooltip]="'COMMON.content_complete_certificate' | translate:{ certificate: certificationsTitle }" class="content-card__body--label-item">
          <lib-icon icon="certificate" [size]="16"></lib-icon> {{'COMMON.certificate' | translate}}
        </div>
      }
      @if (data.progress === 100) {
        <div class="content-card__body--label-item completed-indicator">
          <lib-icon icon="check-circle" [fill]="true"></lib-icon> {{'MODULE_LESSON_CARD.completed' | translate}}
        </div>
      }
      @if (data.progress === 1) {
        <div class="content-card__body--label-item in-progress-indicator">
          <lib-icon icon="circle-dashed" [size]="16"></lib-icon> {{'COMMON.in_progress' | translate}}
        </div>
      }
    </div>
    <div class="content-card__body--title">{{data.title}}</div>
  </div>
</div>
